console.log('menu.js 3');
jQuery(function ($) {
    // Add workshops to submenu
    if ($('.dl-workshops').length > 0) {

        // append child menu items from dl_workshop
        dl_workshops.forEach(function (workshop) {
            li = document.createElement('li');
            li.className = 'c-workshop menu-item menu-item-type-post_type menu-item-object-workshop menu-item' + workshop.id;
            li.innerHTML = '<a href="' + workshop.url + '" class="elementor-sub-item">' + workshop.title + '</a>';
            $('.dl-workshops .sub-menu').append(li);
        });
    }

});